<template>
  <div :class="$style['container']">
    <div :class="$style['title']">
      404<br>NOT FOUND
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
} 
</script>

<style lang="scss" module>
  .container {
    display: flex;
    margin: 0 auto;
    align-items: center;
    justify-content: center;
  }

  .title {
    font-size: 80px;
    text-align: center;
  }
</style>
